import { HomeAddressStreet } from "playbook-ui";

const Address = HomeAddressStreet;

export default Address
